import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;

  .MuiInputAdornment-root svg {
    width: ${props => props.theme.spacing.sp24};
    height: ${props => props.theme.spacing.sp24};
  }
`
